export default "/static/dashboard/build/app/img/v2/cb386384ed0a8c141e50812d957c3570.png";